// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"x_r6 g_hv g_ds g_dw g_dH g_cM g_c7","menuItemSub":"x_r7 g_cT g_ds g_dH","menuMainLink":"x_r8 g_hw g_gm","menuLink":"x_r9 g_hw g_gm","Link":"x_qG p_qG p_p3 p_qn"};